import { Controller } from "@hotwired/stimulus"

// Mostra o nasconde parti di un form secondo il valore di un campo (es. le sezioni dell'ambito territoriale).
//   <div data-controller="mostra-se" data-action="change->mostra-se#aggiorna">
//     <input data-mostra-se-target="campo" …>
//     <div data-mostra-se-target="blocco" data-mostra-se-valori="regione provincia">…</div>
// Un blocco è visibile quando il valore del campo è tra i suoi `valori` (separati da spazi).
export default class extends Controller {
  static targets = ["campo", "blocco"]

  connect() {
    this.aggiorna()
  }

  aggiorna() {
    if (!this.hasCampoTarget) return
    const v = this.campoTarget.type === "checkbox" ? String(this.campoTarget.checked) : this.campoTarget.value
    this.bloccoTargets.forEach((b) => {
      b.hidden = !(b.dataset.mostraSeValori || "").split(/\s+/).includes(v)
    })
  }
}
